import { render, staticRenderFns } from "./DetalleCajaChica.vue?vue&type=template&id=8a9ef3da&"
import script from "./DetalleCajaChica.vue?vue&type=script&lang=js&"
export * from "./DetalleCajaChica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DetalleCajaChica.vue"
export default component.exports